import { ScrollView, View } from 'react-native';
import { HelperText } from 'react-native-paper';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import Toast from 'react-native-toast-message';
import LoadingIndicator from 'src/presentation/components/molecules/LoadingIndicator';
import { useAuthStore } from 'src/domain/stores/useAuthStore';
import { usePreferencesStore } from 'src/domain/stores/usePreferencesStore';
import { useServicesStore } from 'src/domain/stores/useServicesStore';
import MenuRow from 'src/presentation/components/molecules/MenuRow';
import { useTabBarInset } from 'src/presentation/hooks/useTabBarInset';
import useAppStateScreenListener from 'src/presentation/hooks/useAppStateScreenListener';
import Dimens from 'src/core/utils/Dimens';
import Styles from 'src/core/utils/Styles';
import Constants from 'src/core/utils/Constants';
import Translations from 'src/core/utils/Translations';

export default function NotificationPreferencesScreen() {
	const insets = useSafeAreaInsets();
	const tabBarInset = useTabBarInset();
	const { user } = useAuthStore();
	const { appNotifications, isLoading, errorMessage, getApiPreferences, putApiAppNotificationPreference } =
		usePreferencesStore();
	const { logEvent } = useServicesStore();

	useAppStateScreenListener({
		onInit: () => getApiPreferences(),
	});

	const saveAppNotificationsPreference = async (id: string, selected: boolean) => {
		await putApiAppNotificationPreference({
			id,
			selected: !selected,
			onSuccess: () => {
				logEvent({
					name: Constants.analyticsEventChangeAccountSettings,
					params: {
						[Constants.analyticsParamScreenPage]: Constants.screenNotificationPreferences,
						[Constants.analyticsParamSelectItem]:
							Constants.analyticsValueSelectItemNotificationsPrefix +
							(!selected ? Constants.analyticsValueToggleOn : Constants.analyticsValueToggleOff),
					},
					user,
				});

				Toast.show({
					type: Constants.toastTypeSuccess,
					text2: Translations.yourAdjustmentHasBeenProcessedInOurDatabaseItMayTakeUpTo24HoursForYourAdjustmentToBeProcessed,
					topOffset: insets.top + Dimens.padding10,
				});
			},
		});
	};

	return (
		<View style={Styles.screen.white}>
			{isLoading ? (
				<LoadingIndicator style={{ flex: Dimens.flex1 }} />
			) : (
				<ScrollView contentContainerStyle={{ paddingBottom: tabBarInset }}>
					<HelperText type="error" visible={errorMessage !== null}>
						{errorMessage}
					</HelperText>
					{appNotifications &&
						Object.entries(appNotifications).map(([key, notification]) => {
							return (
								<MenuRow
									key={key}
									label={notification.name}
									switch={true}
									value={notification.selected}
									onValueChange={() => saveAppNotificationsPreference(notification.id, notification.selected)}
								/>
							);
						})}
				</ScrollView>
			)}
		</View>
	);
}
